export const ANNOUNCE_EXCEL_START_CELL = 'B15';
// FIXME: 暫定対応で月次3ヶ月→日次の想定で Q15 にしているが、エクセルの内容に応じて可変になる必要がある
export const DAILY_ANNOUNCE_START_DAY_CELL = 'Q15';
export const EXCEL_SERIAL_DATE_MIN = 30000;
